export default "__VITE_ASSET__109b9cc0__"